const actions = {
    BATCH_INVOICING_SET_EXTENDED_MODE: 'BATCH_INVOICING_SET_EXTENDED_MODE',
    BATCH_INVOICING_SET_TAX_INCLUSIVE: 'BATCH_INVOICING_SET_TAX_INCLUSIVE',
    BATCH_INVOICING_SET_STATUS: 'BATCH_INVOICING_SET_STATUS',
    BATCH_INVOICING_SET_MYINVOIS_ACTION: 'BATCH_INVOICING_SET_MYINVOIS_ACTION',
    BATCH_INVOICING_CREATE_REQUEST: 'BATCH_INVOICING_CREATE_REQUEST',
    BATCH_INVOICING_CREATE_SUCCESS: 'BATCH_INVOICING_CREATE_SUCCESS',
    BATCH_INVOICING_CREATE_ERROR: 'BATCH_INVOICING_CREATE_ERROR',
    BATCH_INVOICING_RESET_STATE: 'BATCH_INVOICING_RESET_STATE',

    setExtendedMode: extendedMode => ({
        type: actions.BATCH_INVOICING_SET_EXTENDED_MODE,
        extendedMode,
    }),
    setTaxInclusive: taxInclusive => ({
        type: actions.BATCH_INVOICING_SET_TAX_INCLUSIVE,
        taxInclusive,
    }),
    setStatus: status => ({
        type: actions.BATCH_INVOICING_SET_STATUS,
        status,
    }),
    setMyInvoisAction: myInvoisAction => ({
        type: actions.BATCH_INVOICING_SET_MYINVOIS_ACTION,
        myInvoisAction,
    }),
    create: tableName => ({
        type: actions.BATCH_INVOICING_CREATE_REQUEST,
        tableName,
    }),
    resetState: () => ({
        type: actions.BATCH_INVOICING_RESET_STATE,
    }),
};
export default actions;
